var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadcrumbs
    }
  }), _vm.loading ? [_c('Loader', {
    attrs: {
      "content-id": _vm.addressId,
      "message": 'Fetching Address Details'
    }
  })] : [!_vm.address ? _c('HTTPError', {
    attrs: {
      "id": _vm.addressId,
      "title": 'Address Details Not Found',
      "message": 'A record for this address ID was not found in the Avalanche Explorer',
      "support-u-r-l": 'https://chat.avalabs.org'
    }
  }) : [_vm._v(" EVM Address ")]]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }